import { AxiosError } from 'axios';
import { useQuery, UseQueryOptions } from 'react-query';

import { useWorkspaceId } from '@app/hooks/useWorkspaceId';
import {
  ExportInputValuesStatusByJobIdResponse,
  getExportInputValuesStatusByJobId,
} from '@app/store/transport-layer/document/export-input-values-jobs';

export default function useExportInputValuesStatus(
  { jobId }: { jobId: string },
  options?: UseQueryOptions<ExportInputValuesStatusByJobIdResponse, AxiosError>
) {
  const workspaceId = useWorkspaceId();

  return useQuery<ExportInputValuesStatusByJobIdResponse, AxiosError>(
    ['exportInputValuesJob', jobId],
    async () => {
      return getExportInputValuesStatusByJobId({ jobId, workspaceId });
    },
    options
  );
}
